import { useState } from 'react';
import { generateMealPlan } from '@/lib/apiService';
import { showErrorToast } from '@/utils/toast-utils';

export const useMealPlanGeneration = () => {
  const [isGenerating, setIsGenerating] = useState(false);

  const handleCreateMealPlan = async (clientId: string) => {
    if (!clientId) return;

    setIsGenerating(true);
    try {
      const planDate = new Date().toISOString().split('T')[0];
      const response = await generateMealPlan(clientId, planDate);
      console.log('Generated meal plan:', response);
      return response;
    } catch (error) {
      console.error('Error generating meal plan:', error);
      showErrorToast(error, "Generation failed");
      throw error;
    } finally {
      setIsGenerating(false);
    }
  };

  return {
    isGenerating,
    handleCreateMealPlan,
  };
};
